import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Snackbar,
  Grid,
} from "@mui/material";
import Alert from "@mui/material/Alert"; // Import Alert for Snackbar
import useFirestore from "../../../../config/fireBaseHook"; // Import useFirestore
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = ({ onRecordAdded }) => {
  const { addData } = useFirestore("ResidenceStatusCodes"); // Specify the collection name
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [formData, setFormData] = useState({
    Residence_Status: "",
    Residence_Status_Code: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addData(formData); // Use Firestore hook's addData
      setLoading(false);
      setSnackbarMessage("Record has been added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setFormData({
        Residence_Status: "",
        Residence_Status_Code: "",
      });
      setOpen(false);
      onRecordAdded(); // Call the callback function to refresh the list
      if (onRecordAdded) onRecordAdded(); // Call the callback function
    } catch (error) {
      console.error("Error adding record:", error);
      setLoading(false);
      setSnackbarMessage("Error adding record.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Record
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <ModalDialogTitle onClose={() => setOpen(false)}>
          Add Record
        </ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Residence Status"
                name="Residence_Status"
                value={formData.Residence_Status}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Residence Status Code"
                name="Residence_Status_Code"
                value={formData.Residence_Status_Code}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Add;
